import styled from '@emotion/styled';
import { FONT, COLORS3 } from '../../styles/emotion';
import { LinkV2 } from '../LinkV2';
import { ButtonV3 } from '../ButtonV3';

export const Container = styled.div`
  position: relative;
  width: 100%;
  max-width: 400px;
  margin: 0 auto;
  padding: 24px;
  background-color: ${COLORS3.WHITE_100};
  border-radius: 16px;
  overflow: auto;

  video {
    width: calc(~'100% + 48px');
    margin: 0 -24px 0 -24px;
  }
`;

export const Content = styled.div`
  margin-bottom: 16px;
  color: ${COLORS3.BLACK_100};

  h3 {
    margin-bottom: 8px;
    font-weight: ${FONT.FONT_WEIGHT_SEMI_BOLD};
    ${FONT.textSizeUltraCompact(FONT.FONT_SIZE_REGULAR)}
  }

  p {
    margin-bottom: 4px;
    ${FONT.textSizeCompact(FONT.FONT_SIZE_SMALL)}
  }
`;

export const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const Progress = styled.div`
  color: ${COLORS3.BLACK_050};
  ${FONT.textSizeUltraCompact(FONT.FONT_SIZE_SMALLER)};
`;

export const PrimaryButton = styled(ButtonV3)`
  min-width: 96px;
`;

export const SkipLink = styled(LinkV2)`
  position: absolute;
  top: 24px;
  right: 24px;
  color: ${COLORS3.BLACK_050};
`;
